export default __webpack_public_path__ + "static/media/twitter_logo.abb8fb11.svg";